import React, { useEffect, useState } from 'react';
import { Descriptions, Drawer, Space, Spin, Tag, Typography } from 'antd';
import { Service, getService } from '../api/serviceCatalog';

const { Text } = Typography;

interface Props {
  open: boolean;
  onClose: () => void;
  serviceId: number | null;
  width?: number;
  extra?: React.ReactNode;
  refreshKey?: number;
}

const ServiceInfoDrawer: React.FC<Props> = ({ open, onClose, serviceId, width = 460, extra, refreshKey }) => {
  const [data, setData] = useState<Service | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open || !serviceId) return;
    setLoading(true);
    setData(null);
    getService(serviceId).then(setData).catch(() => {}).finally(() => setLoading(false));
  }, [open, serviceId, refreshKey]);

  return (
    <Drawer title={data?.name || 'Услуга'} open={open} onClose={onClose} width={width} extra={extra}>
      {loading ? (
        <div style={{ textAlign: 'center', padding: 40 }}><Spin /></div>
      ) : data && (
        <>
          <Space wrap style={{ marginBottom: 16 }}>
            {data.is_active ? <Tag color="green">Активна</Tag> : <Tag>Архив</Tag>}
          </Space>

          <Descriptions column={1} size="small" bordered style={{ marginBottom: 16 }}>
            <Descriptions.Item label="Наименование">{data.name}</Descriptions.Item>
            {data.default_price != null && (
              <Descriptions.Item label="Цена по умолчанию">
                {Number(data.default_price).toLocaleString('ru-RU')} ₽ / {data.unit}
              </Descriptions.Item>
            )}
            <Descriptions.Item label="Единица">{data.unit}</Descriptions.Item>
            {data.default_warranty_days != null && (
              <Descriptions.Item label="Гарантия">{data.default_warranty_days} дн.</Descriptions.Item>
            )}
            <Descriptions.Item label="Порядок">{data.sort_order}</Descriptions.Item>
          </Descriptions>

          {data.notes && (
            <div>
              <Text strong>Примечание</Text>
              <div style={{ marginTop: 8, color: '#555', whiteSpace: 'pre-wrap' }}>{data.notes}</div>
            </div>
          )}
        </>
      )}
    </Drawer>
  );
};

export default ServiceInfoDrawer;
